import {
  CountryTaxNewsWithNestedObjectsResponse,
  TaxByJurisdictionResponse,
} from 'src/app/web-api-client';
import { TaxNewsPanel } from '../models/tax-news-panel';

export const mapTaxNewsPanelFromResponse = (
  {
    countryTaxNewsId,
    countryTaxNewsLinks,
    name,
    newsDate,
    description,
  }: CountryTaxNewsWithNestedObjectsResponse,
  taxByJurisdictionData: TaxByJurisdictionResponse[],
  selectedCountryCode?: string
): TaxNewsPanel => {
  return {
    countryTaxNewsId,
    countryName: countryTaxNewsLinks
      ? countryTaxNewsLinks.find(country => {
          if (selectedCountryCode) {
            return taxByJurisdictionData.some(
              tax =>
                selectedCountryCode === country.country?.code &&
                tax.countryId === country.country?.countryId
            );
          }
          return taxByJurisdictionData.some(
            tax => tax.countryId === country.country?.countryId
          );
        })?.country?.name
      : '',
    name,
    date: newsDate,
    description,
  } as TaxNewsPanel;
};
